import React, { useState } from "react";
import styles from './styles.module.css'
import Title from '../../components/Title'
import TextInput from '../../components/TextInput'
import ButtonOutline from '../../components/ButtonOutline'
import colors from '../../colors.js'
import { sendPasswordReset } from "../../firebase";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [successMsg, setSuccessMsg] = useState(false);
  const [errMsg, setErrMsg] = useState(false);

  const forgotPassword = () => {
    if (!email) {
      setErrMsg("Your email is required");
      return; 
    }
    sendPasswordReset(email, setSuccessMsg, setErrMsg);
  };


  return (
    <div className={styles.loginContainer}>
        <div className={styles.logoContainer}>
            <img className={styles.logoImg} src='logo.png' alt="RENR logo (leaf)"/>
            <Title>Welcome to RENR Safety App</Title>
        </div>
        <div className={styles.loginForm}>
            <TextInput label={'email'} setText={setEmail} type='email' name={'email'}/>
            <div className={styles.messages}>
            {errMsg && <p className={styles.errMsg}>{errMsg}</p>}
            {successMsg && <p className={styles.successMsg}>{successMsg}</p>}
            </div>
            <div className={styles.buttonGroup}>
              <ButtonOutline color={colors.green} onClick={forgotPassword}>Reset Password</ButtonOutline>
            </div>
        </div>
    </div>
  )
}

export default ForgotPassword;